<template>
  <div id="facilityBuddy">
    <Loader v-if="isFacilityLoading" />
    <v-card v-else>
      <v-toolbar elevation="0">
        <v-btn icon @click="routeToFaciltiiesList">
          <v-icon size="40">mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Facility</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="primary" :loading="saving" @click="updateFacility">
          Save Changes
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>
      <v-container fluid grid-list-lg>
        <v-layout wrap>
          <v-flex lg6 md6 xs12>
            <v-card
              elevation="12"
              min-height="420"
            >
              <v-img
                :src="facilityStaffHubLogoUrl"
                min-height="250"
                height="280"
              ></v-img>
              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="Facility Name"
                  v-model="selectedFacility.name"
                ></v-text-field>
              </v-card-title>

              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="MCare Care API Key"
                  v-model="selectedFacility.careApiKey"
                ></v-text-field>
              </v-card-title>

              <v-card-title v-if="facility?.dateTimeCreated">
                <v-text-field readonly 
                :value="(selectedFacility.dateTimeCreated.seconds * 1000)| localizedDate(selectedFacility.dateFormat)"
                class="pa-2" label="Creation date">
                </v-text-field> 
              </v-card-title>


              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="Facility Ref ID"
                  description='bla'
                  v-model="selectedFacility.refId"
                ></v-text-field> 
              </v-card-title>  
              <p class="pl-6">The Facility Ref ID is used for integrations such as with MCare, where the location Hubspot ID should be entered.  </p>           
              
              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Active Licence"
                  v-model="selectedFacility.isLicenced"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>Modules </v-card-title>
              <p class="pl-6">By enabling Modules below, it will select the checkboxes on the right which turn on and off the relevant features for that module. </p>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Digital Signage"
                  v-model="digitalSignageModule"
                  @change="onDigitalSignageModuleChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="ResHub Core"
                  v-model="resHubCoreModule"
                  @change="onResHubCoreModuleChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Family engagement"
                  v-model="familyEngagementModule"
                  @change="onFamilyModuleChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="ResHub Plus"
                  v-model="resHubPlusModule"
                  @change="onResHubPlusModuleChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Other"
                  v-model="otherModule"
                  @change="onOtherModuleChange"
                ></v-checkbox>
              </v-card-title>

            </v-card>
          </v-flex>

          <v-flex v-if="selectedFacility.skin === 'default'" lg6 md6 xs12>
            <v-card elevation="12" min-height="700">
              <v-list flat subheader three-line>
                <v-subheader>{{ $t('Settings.FacilitySettings.DefaultSkinFeatures') }}</v-subheader>

                <v-list-item-group
                  v-model="settings"
                  active-class=""
                  multiple
                  class="facility-settings"
                >
                  <DigitalSignageBundle
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    @send-bundle-value="onDigitalSignageBundleChange"
                    ref="digitalSignageBundleRef"/>

                  <ResHubCoreBundle
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    @send-bundle-value="onResHubCoreBundleChange"
                    ref="resHubCoreBundleRef"/>

                  <FamilyEngagementBundle
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    :facilityCopy="facilityCopy"
                    @send-bundle-value="onFamilyBundleChange"
                    ref="familyBundleRef"/>

                  <ResHubPlusBundle
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    @send-bundle-value="onResHubPlusBundleChange"
                    ref="resHubPlusBundleRef"/>

                  <OtherBundle
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    @send-bundle-value="onOtherBundleChange"
                    ref="otherBundleRef"/>

                </v-list-item-group>
              </v-list>
            </v-card>
          </v-flex>

          <v-flex
            lg12
            md12
            xs12
          >
            <v-card
              elevation="12"
              min-height="500"
            >
              <v-card-title
                >Facility Staff Users
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('GeneralTranslations.Search')"
                  single-line
                  hide-details
                ></v-text-field>

                <v-btn
                  class="primary mr-5 ml-5"
                  @click="openManageRolesDialog"
                >
                  {{ $t('Settings.StaffUsersList.ManageRoles') }}
                </v-btn>

                <v-btn
                  class="primary mr-5"
                  @click="openUserAddRoleDialog"
                >
                Add New Role
              </v-btn>
                <v-dialog
                  v-model="dialog"
                  max-width="600px"
                  persistent
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="primary"
                      v-bind="attrs"
                      v-on="on"
                      >{{ $t('Settings.StaffUsersList.AddUser') }}</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{
                        $t('Settings.StaffUsersList.CreateUser')
                      }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container class="p-0">
                        <validation-observer
                          ref="observer"
                          v-slot="{ invalid }"
                        >
                          <v-form
                            ref="createUserForm"
                            lazy-validation
                            id="create-user-form"
                            @submit.prevent="submit"
                          >
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Name"
                                rules="required"
                              >
                                <v-text-field
                                  v-model="form.name"
                                  :label="
                                    $t('Settings.StaffUsersList.Name') + '*'
                                  "
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Email"
                                rules="required|email"
                              >
                                <v-text-field
                                  v-model="form.email"
                                  :label="
                                    $t('Settings.StaffUsersList.EmailAddress') +
                                    '*'
                                  "
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="FacilityAccess"
                                rules="required"
                              >
                                <v-select
                                  v-model="form.facilities"
                                  :items="facilitiesForOrg"
                                  :error-messages="errors"
                                  item-text="name"
                                  :label="
                                    $t(
                                      'Settings.StaffUsersList.FacilityAccess'
                                    ) + '*'
                                  "
                                  multiple
                                  required
                                  return-object
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="AccessLevel"
                                rules="required"
                              >
                                <v-select
                                  v-model="form.accessLevel"
                                  :items="staffAccessLevels"
                                  :error-messages="errors"
                                  :label="
                                    $t('Settings.StaffUsersList.AccessLevel') +
                                    '*'
                                  "
                                  required
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Role"
                                rules=""
                              >
                                <v-select
                                  class="autofocus"
                                  v-model="form.role"
                                  :items="usersRoles"
                                  item-text="name"
                                  :label="$t('Settings.StaffUsersList.Role')"
                                  :error-messages="errors"
                                  required
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="!isStaffUserInviteEmailTemplateExists"
                            >
                              <v-alert
                                dense
                                outlined
                                color="error"
                              >
                                <v-row align="center">
                                  <v-col
                                    cols="8"
                                    class="text-subtitle-2"
                                  >
                                    {{
                                      $t(
                                        'Settings.StaffUsersList.EmailTemplateWithType'
                                      )
                                    }}
                                    {{
                                      $t(
                                        'Settings.StaffUsersList.MissingStaffUserInviteText'
                                      )
                                    }}
                                  </v-col>
                                  <v-col>
                                    <router-link
                                      @click.native="dialog = false"
                                      class="text-decoration-none"
                                      to="/settings?tab=emailTemplates"
                                      ><v-btn
                                        color="primary"
                                        block
                                      >
                                        {{
                                          $t('GeneralTranslations.Create')
                                        }}</v-btn
                                      ></router-link
                                    >
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-col>

                            <v-col cols="12">
                              <small>{{
                                $t(
                                  'GeneralTranslations.StarIndicatesRequiredField'
                                )
                              }}</small>
                            </v-col>

                            <v-col cols="12">
                              <div class="d-flex">
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="error"
                                  text
                                  class="mr-4"
                                  @click="cancel"
                                  >{{ $t('GeneralTranslations.Cancel') }}</v-btn
                                >
                                <v-btn
                                  color="primary"
                                  :disabled="
                                    invalid ||
                                    submited ||
                                    !isStaffUserInviteEmailTemplateExists
                                  "
                                  :loading="submited"
                                  type="submit"
                                >
                                  {{ $t('Settings.StaffUsersList.CreateUser') }}
                                </v-btn>
                              </div>
                            </v-col>
                          </v-form>
                        </validation-observer>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>

                <!-- <v-btn class="primary ml-5" @click="openUserInvitesDialog">
                Send User Invites
                </v-btn> -->
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="facilityUsers"
                :loading="isFacilityUsersLoading"
                :search="search"
                @click:row="handleClickUser"
                class="pr-8"
              >
                <template v-slot:item.profilePicUrl="{ item }">
                  <v-avatar size="50px" class="mt-3 mb-3">
                    <img :src="item.profilePicUrl" alt />
                  </v-avatar>
                </template>

                <template v-slot:item.isEnabledImpersonation="{ item }">
                  <v-btn class="primary mr-4" v-if="item?.isEnabledImpersonation" :loading="loadingUsers.includes(item.id)" @click="loginAsStaffUser(item)">{{$t('Impersonation.Impersonate')}}</v-btn>
                  <v-btn class="primary" @click="openResetPasswordDialog(item)"> {{ $t('Settings.UserProfile.ResetPassword') }}</v-btn>
                </template>

              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <FacilityUsersRolesDialog ref="facilityUsersRolesDialog" />

      <FacilityUserAddRoleDialog ref="facilityUserAddRoleDialog" />

      <InviteUsersDialog ref="inviteUsersDialogRef"/>

      <v-divider></v-divider>
    </v-card>
    <ResetUserPasswordEmailDialog ref="resetUserPasswordEmailDialog" :user="user" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import 'firebase/firestore';
import * as firebase from 'firebase/app';
import { StaffAccessLevels } from '@/enums/StaffAccessLevels';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { DEFAULT_AVATAR_BLACK } from '@/consts/default-avatar';
import { getRegionName } from '@/utils/functionsRegion';
import FacilityUsersRolesDialog from '@/views/settings/facility/facility-users-roles-dialog/FacilityUsersRolesDialog.vue';
import FacilityUserAddRoleDialog from '@/views/settings/facility/facility-users-add-role-dialog/FacilityUserAddRoleDialog.vue';
import { DefaultEmailTemplateType } from '@/enums/DefaultEmailTemplateType';
import { getEnabledRoute } from "@/router/router-helper";
import Loader from '@/components/loader/Loader.vue';
import ResetUserPasswordEmailDialog from "@/views/settings/userProfile/ResetUserPasswordEmailDialog.vue";
import {batchUpdate} from "@/utils/batchUpdate";
import {serializer} from "@/api/shared/serializer";
import DigitalSignageBundle from '@/buddy/facilities/bundles/digitalSignage/DigitalSignageBundle.vue';
import ResHubCoreBundle from '@/buddy/facilities/bundles/reshubCore/ResHubCoreBundle.vue';
import FamilyEngagementBundle from '@/buddy/facilities/bundles/family/FamilyEngagementBundle.vue';
import ResHubPlusBundle from '@/buddy/facilities/bundles/reshubPlusBundle/ResHubPlusBundle.vue';
import OtherBundle from '@/buddy/facilities/bundles/other/OtherBundle.vue';
import InviteUsersDialog from "@/views/settings/facility/users-invitation/InviteUsersDialog.vue";
import {DEFAULT_NO_IMAGE} from "@/consts/default-no-image";

export default {
  name: 'BuddyFacility',
  computed: {
    ...mapState({
      facilitiesForOrg: state => state.userModule.facilitiesForOrg,
      facilityUsers: state => state.facilityModule.selectedFacilityUsers,
      emailTemplates: state => state.facilityModule.facilityEmailTemplates,
      currentUser: state => state.authModule.user,
      isStaffUserInviteEmailTemplateExists() {
        return (
          this.emailTemplates.filter(
            emailTemplate =>
              emailTemplate.type === DefaultEmailTemplateType.StaffUserInvite
          ).length > 0
        );
      },
      usersRoles() {
        return this.$store.state.userModule.usersRoles;
      },
      isFacilityHasCareAPI: state => state.facilityModule.isFacilityHasCareAPI
    }),

    staffAccessLevels() {
      if(this.selectedFacility?.isEnabledStaffAPI === true) {
          return [StaffAccessLevels.MaintenanceAdmin, StaffAccessLevels.MaintenanceUser]
      }

      return Object.values(StaffAccessLevels);
    },
  },
  components: {
    OtherBundle,
    ResHubPlusBundle,
    FamilyEngagementBundle,
    DigitalSignageBundle,
    ResHubCoreBundle,
    InviteUsersDialog,
    Loader,
    ValidationObserver,
    ValidationProvider,
    FacilityUsersRolesDialog,
    FacilityUserAddRoleDialog,
    ResetUserPasswordEmailDialog
  },
  data() {
    return {
      facility: null,
      isFacilityLoading: true,
      isFacilityUsersLoading: false,
      currentDate: new Date().getDate(),
      search: '',
      accessLevelsEnum: StaffAccessLevels,
      dialog: false,
      arecheckedesdisabled: false,
      saving: false,
      facilityCopy: null,
      facilityStaffHubLogoUrl: DEFAULT_NO_IMAGE,
      headers: [
        {
          text: '',
          align: '',
          sortable: false,
          width: 70,
          value: 'profilePicUrl',
        },
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Access Level',
          align: 'start',
          sortable: false,
          value: 'accessLevel',
        },
        {
          text: 'Email',
          align: 'start',
          sortable: false,
          value: 'email',
        },
        {
          text: '',
          align: 'end',
          sortable: false,
          value: 'isEnabledImpersonation',
        }
      ],
      form: {
        name: '',
        email: '',
        facilities: [],
        accessLevel: '',
        role: '',
      },
      loadingUsers: [],
      familyFeaturesChanged: {
        isCareSummaryChanged: false,
        isCarePlanChanged: false,
        isDailyCareChanged: false,
        isDailyPlanChanged: false
      },
      digitalSignageModule: false,
      resHubCoreModule: false,
      familyEngagementModule: false,
      resHubPlusModule: false,
      otherModule: false,
    };
  },
  async created() {
    this.selectedFacility = await this.$store.dispatch("getBuddyFacility", this.$route.params.id);
    this.facilityStaffHubLogoUrl = this.selectedFacility?.staffHubLogoUrl || DEFAULT_NO_IMAGE

    this.isFacilityLoading = false;
    this.facilityCopy = JSON.parse(JSON.stringify(this.selectedFacility));

    this.isFacilityUsersLoading = true;
    await this.$store.dispatch('getOrgUsers', this.selectedFacility.orgId);
    this.isFacilityUsersLoading = false;

    if(this.$route.params.id) {
      await this.$store.dispatch('getCareAPIKey', this.$route.params.id);
    }
  },
  methods: {
    openResetPasswordDialog(user){
      if (this.$refs.resetUserPasswordEmailDialog) this.$refs.resetUserPasswordEmailDialog.open(user)
    },
    routeToFaciltiiesList() {
      setTimeout(() => this.$router.push('/buddy/facilities'), 2000);
    },
    async updateFacility() {
      this.saving = true;
      this.selectedFacility.modules.digitalSignage.isEnabled = this.digitalSignageModule;
      this.selectedFacility.modules.resHubCore.isEnabled = this.resHubCoreModule;
      this.selectedFacility.modules.familyEngagement.isEnabled = this.familyEngagementModule;
      this.selectedFacility.modules.resHubPlus.isEnabled = this.resHubPlusModule;
      this.selectedFacility.modules.other.isEnabled = this.otherModule;

      this.selectedFacility.modules.familyEngagement.categories.communicationManagement = this.$refs.familyBundleRef.communicationCategory;
      this.selectedFacility.modules.familyEngagement.categories.dailyCare = this.$refs.familyBundleRef.dailyCareCategory;

      try {
        await this.$store.dispatch('updateBuddyFacility', JSON.parse(JSON.stringify(this.selectedFacility)))
            .then(async () => {
              await this.updateFamilyMembersCareSettings();
            })

        this.facilityCopy = JSON.parse(JSON.stringify(this.selectedFacility))
      } catch (error) {
        console.error(error);
      }
      finally {
        this.saving = false;
      }
    },
    async loginAsStaffUser(row) {
      this.loadingUsers.push(row.id);

      const superUserId = this.$store.state.authModule.user.id

      return await firebase.app()
          .functions(getRegionName())
          .httpsCallable('impersonation-getToken')({
            superUserId: superUserId,
            staffUserId: row.id,
            facilityId: row.facilityId
          }).then(async (impersonationTokenResult) => {

            if (impersonationTokenResult.data?.status === 400) {
              this.$toast.open({
                message: impersonationTokenResult.data?.error,
                type: "error"
              });

              return;
            }

            const impersonationCustomToken = impersonationTokenResult.data.token

            //store superUserId and other data in local storage to be able to stop impersonation and sign in as super user
            localStorage.setItem("impersonation", JSON.stringify({ superUserId: superUserId, selectedBuddyFacilityId: this.selectedFacility.id }));

            //get custom token and sign in as impersonated user
            await this.$store.dispatch("signInByCustomToken", {  customToken: impersonationCustomToken })

            //get enabled route for impersonated user (premium features)
            const enabledRoute = getEnabledRoute(this.$store.getters?.premiumFeatures)

            //redirect to enabled route
            this.$router.push(enabledRoute.path);
         
          }).catch(error => {
              this.$toast.open({
                message: error.message,
                type: "error"
              });
          }).finally(() => {
            console.log("Finally")
            this.loadingUsers = this.loadingUsers.filter(x => x !== row.id);
          })
    },
 
    async submit() {
      if (this.submited == true) return true;

      this.submited = true;

      const isValidEmail = await this.validateEmail(this.form.email);

      if (!isValidEmail) {
        this.$refs.observer.setErrors({
          Email: [
            this.$i18n.messages[this.$i18n.locale][
              'GeneralTranslations.EmailAlreadyExists'
            ],
          ],
        });

        this.submited = false;

        return;
      }

      const facilities = this.form.facilities.map(facility => ({
        id: facility.id,
        name: facility.name,
      }));

      const facilitiesIds = this.form.facilities.map(facility => facility.id);
      const facility = this.form.facilities[0];

      const user = {
        ...this.form,
        facilityId: facility.id,
        regionId: facility.regionId,
        orgId: facility.orgId,
        facilities,
        facilitiesIds,
        profilePicUrl: DEFAULT_AVATAR_BLACK,
      };

      if (this.form.role) {
        const roleId = this.usersRoles.find(x => x.name === this.form.role).id;
        user.roleId = roleId;
      } else {
        delete user.role;
      }

      await this.$store
        .dispatch('createNewFacilityUser', {
          user,
          orgId: facility.orgId,
        })
        .finally(() => {
          this.submited = false;
          this.resetForm();
        });

      this.dialog = false;
    },

    resetForm() {
      this.form.name = '';
      this.form.email = '';
      this.form.facilities = [];
      this.form.accessLevel = '';
      this.form.role = '';
      this.$refs.createUserForm.reset();
      this.$refs.observer.reset();
    },
    cancel() {
      this.dialog = false;
      this.resetForm();
    },
    async validateEmail(email) {
      const result = await firebase
        .app()
        .functions(getRegionName())
        .httpsCallable('checkIfEmailExists')({
        emailAddress: email,
        orgId: this.selectedFacility.orgId,
      });

      if (result.data.data.number > 0) {
        return false;
      }

      return true;
    },

    openManageRolesDialog() {
      this.$refs.facilityUsersRolesDialog.open();
    },
    openUserAddRoleDialog() {
      this.$refs.facilityUserAddRoleDialog.open();
    },

    openUserInvitesDialog(){
      this.$refs.inviteUsersDialogRef.open(this.selectedFacility.id, this.selectedFacility.orgId);
    },

    async updateFamilyMembersCareSettings() {
      if(
          this.familyFeaturesChanged.isCareSummaryChanged ||
          this.familyFeaturesChanged.isCarePlanChanged ||
          this.familyFeaturesChanged.isDailyCareChanged ||
          this.familyFeaturesChanged.isDailyPlanChanged
      ) {
        const itemsToUpdate = []
        let familyMembers = []

        await firebase
          .firestore()
          .collection('familyHubUsers')
          .where('facilityId', '==', this.selectedFacility.id)
          .get()
          .then(querySnapshot => {
            familyMembers = serializer.querySnapshotToDocuments(querySnapshot);
          })

        familyMembers.forEach(familyMember => {
          const familyId = familyMember.id;
          const updates = {};
          let isValid = false;

          const updateAccesses = (accesses) => {
            const changes = this.familyFeaturesChanged;
            const facility = this.selectedFacility;

            if (changes.isCareSummaryChanged) accesses.careSummary = facility.isCareSummary;
            if (changes.isCarePlanChanged) {
              accesses.carePlan = facility.isCarePlan;
              accesses.isEnabledCarePlan = facility.isCarePlan;
            }
            if (changes.isDailyPlanChanged) accesses.dailyPlan = facility.isDailyPlan;
            if (changes.isDailyCareChanged) accesses.dailyCare = facility.isDailyCare;
          };

          if (familyMember?.staffControlledFamilyAccesses) {
            updateAccesses(familyMember.staffControlledFamilyAccesses);
            isValid = true;
            updates.staffControlledFamilyAccesses = familyMember.staffControlledFamilyAccesses;
          }

          if (familyMember?.familyAccesses) {
            updateAccesses(familyMember.familyAccesses);
            isValid = true;
            updates.familyAccesses = familyMember.familyAccesses;
          }

          if(isValid) {
            itemsToUpdate.push({ docId: familyId, updates: updates})
          }

        });

        await batchUpdate('familyHubUsers', itemsToUpdate).then(() => {
          console.log(`updated (${itemsToUpdate.length})/${familyMembers.length} family members`)
        });
      }
    },

    // Track bundles changes from child components
    onDigitalSignageBundleChange(value) {
      this.digitalSignageModule = value;
    },
    onResHubCoreBundleChange(value) {
      this.resHubCoreModule = value;
    },
    onFamilyBundleChange(value) {
      this.familyEngagementModule = value;
    },
    onResHubPlusBundleChange(value) {
      this.resHubPlusModule = value;
    },
    onOtherBundleChange(value) {
      this.otherModule = value;
    },

    // Send modules changes to child components
    onDigitalSignageModuleChange(value) {
      this.$refs.digitalSignageBundleRef.digitalSignageBundleUpdate(value);
    },
    onResHubCoreModuleChange(value) {
      this.$refs.resHubCoreBundleRef.resHubCoreBundleUpdate(value);
    },
    onFamilyModuleChange(value) {
      this.$refs.familyBundleRef.familyBundleUpdate(value);
    },
    onResHubPlusModuleChange(value) {
      this.$refs.resHubPlusBundleRef.resHubPlusBundleUpdate(value);
    },
    onOtherModuleChange(value) {
      this.$refs.otherBundleRef.otherBundleUpdate(value);
    },
  },
  watch: {
    'selectedFacility.isCarePlan'(newValue) {
      this.familyFeaturesChanged.isCarePlanChanged = true;
      this.selectedFacility.isEnabledCarePlan = newValue;
    },
    'selectedFacility.isCareSummary'(newValue) {
      this.familyFeaturesChanged.isCareSummaryChanged = true;
    },
    'selectedFacility.isDailyPlan'(newValue) {
      this.familyFeaturesChanged.isDailyPlanChanged = true;
    },
    'selectedFacility.isDailyCare'(newValue) {
      this.familyFeaturesChanged.isDailyCareChanged = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application #user-management {
  .v-card {
    box-shadow: none !important;
  }
}

.facility-settings {
  h4 {
    margin-top: 3px;
    margin-bottom: 10px !important;
  }
  h5 {
    margin-top: 5px;
    margin-bottom: 10px !important;
  }
}

::v-deep.facility-settings ::v-deep.v-list-item__action {
  margin-right: 15px !important;
}
</style>
